__turbopack_context__.v({
  "title": "PerformersList-module-scss-module__kgm3XG__title",
  "visuallyHidden": "PerformersList-module-scss-module__kgm3XG__visuallyHidden",
});
